module.exports = __webpack_public_path__ + "img/ch9.f282e020.jpg";